import { Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";

const SiteAssistant = lazy(() => import("@/components/common/SiteAssistant").then((m) => ({ default: m.SiteAssistant })));

const NUMBER = "393791108935";
const TEXT = encodeURIComponent("Ciao, ho bisogno di assistenza su SnapQuote");
const CASA_TEXT = encodeURIComponent("Ciao, ho una domanda su SnapQuote Casa");
const HIDDEN = ["/q/", "/c/", "/v/", "/carica/", "/admin", "/story-export", "/snapbid-video-export", "/explainer-export", "/esempi/", "/founder", "/academy", "/impresa/"];

export function WhatsAppButton() {
  const { pathname } = useLocation();
  if (HIDDEN.some((p) => pathname.startsWith(p)) || pathname.startsWith("/casa/studio")) return null;
  const raised = pathname.startsWith("/app");
  const casa = pathname.startsWith("/casa");
  if (!raised && !casa) return <Suspense fallback={null}><SiteAssistant /></Suspense>;
  return (
    <a
      href={`https://wa.me/${NUMBER}?text=${casa ? CASA_TEXT : TEXT}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Assistenza su WhatsApp"
      title="Assistenza su WhatsApp"
      data-testid="whatsapp-support-btn"
      className={`fixed right-4 lg:right-6 lg:bottom-6 z-[80] w-14 h-14 rounded-full flex items-center justify-center shadow-2xl bg-[#25D366] hover:scale-105 active:scale-95 transition-transform [.menu-open_&]:hidden [[data-scroll-locked]_&]:hidden [.sofia-hero-visible_&]:hidden max-sm:[.sofia-cta-visible_&]:hidden ${raised ? "bottom-24" : "bottom-[calc(0.75rem+env(safe-area-inset-bottom))]"}`}
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="#fff" aria-hidden="true">
        <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.11.56 4.17 1.62 5.99L4 29l8.23-1.6a12.1 12.1 0 0 0 3.8.61h.01C22.67 28.01 28 22.65 28 16.04 28 9.43 22.67 3 16.04 3zm0 22.82h-.01a9.9 9.9 0 0 1-5.04-1.38l-.36-.21-4.88.95.97-4.74-.24-.38a9.8 9.8 0 0 1-1.52-5.09c0-5.42 4.42-9.83 9.09-9.83 5.4 0 9.82 4.41 9.82 9.9 0 5.45-4.42 10.78-7.83 10.78zm5.4-7.36c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.6-.92-2.2-.24-.57-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.01-1.04 2.47 0 1.45 1.06 2.86 1.21 3.06.15.2 2.09 3.18 5.06 4.46.71.3 1.26.49 1.69.63.71.22 1.36.19 1.87.12.57-.09 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35z" />
      </svg>
    </a>
  );
}
